module.exports = __webpack_public_path__ + "adyen.0d6fc74988998446f630d42d1dd116f6.svg";